import SDARelateDA from './SDARelateDA'

export default class SDAItem {
    constructor(data = {}) {
        this.PartnerMvItm_ID = data.PartnerMvItm_ID || null
        this.Product_ID = data.Product_ID || ''
        this.ProductName = data.ProductName || ''
        this.AvailPosot = data.AvailPosot || 0
        this.StartPosot = data.StartPosot || 0
        this.RelateDA = (data.RelateDA || []).map(da => new SDARelateDA(da))
    
    }
} 